window.app = window.app || {};

import {loadScript, debounce} from './helpers';

const GOOGLE_API_KEY = 'AIzaSyDAYDs2Mmnfd_Z2aYE4xqjJMczfLNCYr20';
const mapsApiUrl = 'https://maps.googleapis.com/maps/api/js';
const mapsApiParams = {
    v: '3.exp',
    key: GOOGLE_API_KEY,
    language: i18n.language,
    region: i18n.region
};

var mapElement = document.getElementById('map-canvas');
var boundOnCountry = (typeof $(mapElement).data('bound-country') !== 'undefined') ? $(mapElement).data('bound-country') : true;

window.app.maps = function () {
    var lightGray = [{
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [{"color": "#d3d3d3"}]
    }, {
        "featureType": "transit",
        "stylers": [{"color": "#808080"}, {"visibility": "off"}]
    }, {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [{"visibility": "on"}, {"color": "#b3b3b3"}]
    }, {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [{"color": "#ffffff"}]
    }, {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [{"visibility": "on"}, {"color": "#ffffff"}, {"weight": 1.8}]
    }, {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [{"color": "#d7d7d7"}]
    }, {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [{"visibility": "on"}, {"color": "#ebebeb"}]
    }, {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [{"color": "#a7a7a7"}]
    }, {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [{"color": "#ffffff"}]
    }, {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [{"color": "#ffffff"}]
    }, {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [{"visibility": "on"}, {"color": "#efefef"}]
    }, {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [{"color": "#696969"}]
    }, {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [{"visibility": "on"}, {"color": "#737373"}]
    }, {"featureType": "poi", "elementType": "labels.icon", "stylers": [{"visibility": "off"}]}, {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [{"visibility": "off"}]
    }, {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [{"color": "#d6d6d6"}]
    }, {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [{"visibility": "off"}]
    }, {}, {"featureType": "poi", "elementType": "geometry.fill", "stylers": [{"color": "#dadada"}]}];

    var mapOptions = {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        scrollwheel: false,
        styles: []
    };
    var customMarker = {
        url: '/img/map-pointer.png',
        size: new google.maps.Size(64, 84),
        anchor: new google.maps.Point(32, 42)
    };
    var map = new google.maps.Map(mapElement, mapOptions);
    map.active_window = false;

    function load() {
        var points = JSON.parse(mapElement.dataset.pointsObj);

        if (points.length) {
            renderPoints(points);
        } else {
            renderMaps();
        }
    }

    function renderMaps() {
        map.setOptions({styles: lightGray});

        var bounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(25.820898, -124.712891),
            new google.maps.LatLng(49.380240, -66.940662)
        );
        map.fitBounds(bounds);
        google.maps.event.addDomListener(window, 'resize', debounce(function () {
            map.fitBounds(bounds);
        }));
    }

    function renderPoints(points) {
        var markers = [];
        var bounds = new google.maps.LatLngBounds();

        // Load style from https://snazzymaps.com/
        map.setOptions({styles: lightGray});

        var marker;
        var translations = {
            "en": {
                "calculate": "Calculate route"
            },
            "fr": {
                "calculate": "Calculate"
            }
        };

        for (var index in points) {
            var point = points[index];
            var latLng = new google.maps.LatLng(point.lat, point.lng);

            marker = new google.maps.Marker({
                position: latLng,
                map: map,
                lat: point.lat,
                lng: point.lng,
                icon: customMarker
            });

            marker.id = index;
            markers.push(marker);
            bounds.extend(latLng);

            var locationInfoWindow = $('#location-marker-info-' + point.id);
            var sideBarItem = $('#item-' + point.id);

            if (typeof locationInfoWindow.html() !== 'undefined' && typeof sideBarItem.html() !== 'undefined') {
                // Create a click on the sidebar list and open the info window
                (function (inner_marker) {
                    sideBarItem.on('click', function () {
                        // Close info windows
                        if (map.active_window != false) {
                            map.active_window.infoWindow.close(map, map.active_window.marker);
                        }
                        // Click on the marker
                        google.maps.event.trigger(inner_marker, "click");
                    });
                }(marker));
            }

            if (typeof locationInfoWindow.html() !== 'undefined') {
                google.maps.event.addListener(marker, 'click', showInfoWindow);
            }
        }

        if (i18n.region !== '' && boundOnCountry) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({address: i18n.name}, function (results) {

                // var bounds = new google.maps.LatLngBounds(results[0].geometry.bounds.getNorthEast(), results[0].geometry.bounds.getSouthWest());
                map.fitBounds(results[0].geometry.bounds);

                google.maps.event.addDomListener(window, 'resize', debounce(function () {
                    map.fitBounds(results[0].geometry.bounds);
                }));
            });
        } else {
            if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                bounds.extend(new google.maps.LatLng(bounds.getNorthEast().lat() + 0.05, bounds.getNorthEast().lng() + 0.05));
                bounds.extend(new google.maps.LatLng(bounds.getSouthWest().lat() - 0.05, bounds.getSouthWest().lng() - 0.05));
            }

            map.fitBounds(bounds);

            google.maps.event.addDomListener(window, 'resize', debounce(function () {
                map.fitBounds(bounds);
            }));
        }

        var mcOptions = {

            styles: [{
                url: "/img/cluster/m1.png",
                width: 53,
                height: 53,
                textSize: 16,
                textColor: "white"
            },
                {
                    url: "/img/cluster/m2.png",
                    width: 56,
                    height: 56,
                    textSize: 16,
                    textColor: "white"
                },
                {
                    url: "/img/cluster/m3.png",
                    width: 66,
                    height: 66,
                    textSize: 16,
                    textColor: "white"
                },
                {
                    url: "/img/cluster/m4.png",
                    width: 78,
                    height: 78,
                    textSize: 16,
                    textColor: "white"
                },
                {
                    url: "/img/cluster/m5.png",
                    width: 90,
                    height: 90,
                    textSize: 16,
                    textColor: "white"
                }]

        };

        // var markerCluster = new MarkerClusterer(map, markers, mcOptions);

        function showInfoWindow() {
            var infoWindow = new google.maps.InfoWindow({
                content: 'Loading…'
            });

            if (map.active_window != false) {
                map.active_window.infoWindow.close(map, map.active_window.marker);
            }

            var locationId = $('#location-marker-info-' + points[this.id].id);
            infoWindow.setContent([locationId.html()].join('\n'));

            // var mapVideo = $(locationId.html()).find('.js-map-video');
            //
            // if (mapVideo.length) {
            //     $(mapVideo).modaal({
            //         type: 'video'
            //     });
            // }

            infoWindow.open(map, this);
            map.active_window = {infoWindow: infoWindow, marker: this};
        }
    }


    load();
};

if (mapElement !== null && (typeof google === 'undefined' || !google.hasOwnProperty('maps'))) {
    loadScript(mapsApiUrl + '?' + $.param(mapsApiParams), window.app.maps);
}
